import Extractor from './extractor.js';

class Twitter extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    result['has_data'] = (result['screenname']) ? 1 : 0;

    return result;
  }
}

export default (Twitter);


// WEBPACK FOOTER //
// ./src/search/extractor/twitter.js